import { useParams } from "react-router-dom";

import useOneMember from "../../../hooks/useOneMember";
import useOneMemberCI from "../../../hooks/useOneMemberCI";
import MemberProfileBaseView from "../components/MemberProfileBaseView";
import { useTranslate } from "react-admin";
import { Loading, Error } from "ra-ui-materialui";
import { getFieldBlock } from "../../../helper/FormBlockHelper";
import { useLocale } from "react-admin";
const PersonaandLifeStyleView = () => {
  const { id } = useParams();
  const locale = useLocale();
  const translate = useTranslate();
  const {
    member: ci,
    form,
    loading: ciLoading,
    error: ciError,
  } = useOneMemberCI(id);
  const { member, loading, error } = useOneMember(id);
  if (loading || ciLoading) return <Loading />;
  if (error || ciError) return <Error error={error} />;

  const blockListData = form.fields
    .map((f) =>
      getFieldBlock({
        field: f,
        lang: locale,
      })
    )
    .filter((data) => data !== null);

  const addedValueBlockData = blockListData.map((data) => ({
    ...data,
    value: ci[data.key],
  }));

  const MEMBER_INFO_DATAS = ["merchant_remark"];
  const INTEREST_INFO_DATAS = [
    "hobbies",
    "colors",
    "fashion_brands",
    "shopping_places",
    "online_shopping",
    "hangouts",
    "books",
    "movies",
  ];

  const memberDatas = MEMBER_INFO_DATAS.map((DATA) => {
    return addedValueBlockData.find((data) => data.key === DATA);
  });

  const interestDatas = INTEREST_INFO_DATAS.map((DATA) => {
    return addedValueBlockData.find((data) => data.key === DATA);
  });
  const testTab = [
    {
      title: "",
      blocks: [
        {
          title: translate("ra.text.ci.personasLifestyle.memberInformation"),
          isArray: false,
          datas: memberDatas,
        },
        {
          title: translate("ra.text.ci.personasLifestyle.interestAndValues"),
          isArray: false,
          datas: interestDatas,
        },
      ],
    },
  ];

  return (
    <MemberProfileBaseView
      title={translate("ra.text.personasandInformation")}
      tabs={testTab}
      member={member}
      ci={ci}
    />
  );
};

export default PersonaandLifeStyleView;
